import { render, staticRenderFns } from "./importStatusDialog.vue?vue&type=template&id=2b0964e6&"
import script from "./importStatusDialog.vue?vue&type=script&lang=js&"
export * from "./importStatusDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports